<template>
  <OfferComparisonCard
    :benefits
    dialog-name="us-telco-comparators-visible-by-verizon"
    former-price="$20.00"
    :name="i18n(translations.name)"
    price="$15.00"
    :trustpilot-rating="4.5"
  >
    <template #logo>
      <RevIllustration
        alt=""
        class="size-32 shrink-0"
        :height="32"
        src="/img/visible-by-verizon/visible-by-verizon-logo-square.svg"
        :width="32"
      />
    </template>

    <template #info>
      <RevInfoBlock
        :content="i18n(translations.promoContent)"
        :icon="IconPriceTag"
        :title="i18n(translations.promoTitle)"
        variant="success"
      />
    </template>

    <template #modal>
      <div class="space-y-24">
        <div class="px-80 py-40">
          <RevIllustration
            alt=""
            :height="48"
            image-class-names="w-full h-auto"
            src="/img/visible-by-verizon/logo-with-backmarket-blue.svg"
            :width="258"
          />
        </div>

        <ModalStepsList :steps="modalSteps" />

        <RevButton
          full-width="always"
          :to="i18n(translations.modalCtaLink)"
          variant="primary"
        >
          {{ i18n(translations.modalCtaLabel) }}
        </RevButton>
      </div>
    </template>
  </OfferComparisonCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconPriceTag } from '@ds/icons/IconPriceTag'

import OfferComparisonCard from '../OfferComparisonCard/OfferComparisonCard.vue'
import ModalStepsList from '../OfferComparisonCard/components/ModalStepsList/ModalStepsList.vue'

import translations from './VisibleByVerizonOfferCard.translations'

const i18n = useI18n()

const benefits = computed(() => [
  i18n(translations.benefitNetwork),
  i18n(translations.benefitUnlimited),
  i18n(translations.benefitFamily),
])

const modalSteps = computed(() => [
  i18n(translations.modalStep1),
  i18n(translations.modalStep2),
  i18n(translations.modalStep3),
])
</script>
